import { render, staticRenderFns } from "./CadastroFormInput.vue?vue&type=template&id=159165fe&scoped=true&lang=pug&"
import script from "./CadastroFormInput.vue?vue&type=script&lang=js&"
export * from "./CadastroFormInput.vue?vue&type=script&lang=js&"
import style0 from "./CadastroFormInput.vue?vue&type=style&index=0&id=159165fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159165fe",
  null
  
)

export default component.exports